import http from "./http";
export default {
    scheme: "https",
    domainHost: http.domainHost,
    parse: http.parse,
    serialize: http.serialize
};
//# sourceMappingURL=https.js.map